import React from 'react';
import MainWrapper from './MainWrapper';
import {store} from '../store/store';
import {Provider} from 'react-redux';
import {getCurrentUser} from '../actions/userActions';
import RedirectHelper from "../services/RedirectHelper";


RedirectHelper.redirect();

store.dispatch(getCurrentUser());

const App = () => {
    return (
        <Provider store={store}>
            <MainWrapper/>
        </Provider>
    )

};

export default App;


// WEBPACK FOOTER //
// ./web/src/components/App.jsx